import { useDoorValues } from '@/const/useDoorValues'
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { Logger } from 'aws-amplify'

const logger = new Logger('usePostMessage')

export const usePostMessage = () => {
  const receiveToken = () => {
    const store = useStore()
    const token = ref(store.getters['apiParam/jwtToken'])
    const { containsOrigin } = useDoorValues()

    watch(token, (value) => {
      store.dispatch('apiParams/setJwtToken', value)
    })

    window.addEventListener('message', (event) => {
      const origin = event.origin
      if ( !containsOrigin(origin) ) {
        return
      }
      logger.info('Receive token from', origin)
      token.value = event.data
    })
  }
  return {
    receiveToken
  }
}
